import Axios from "axios";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
import { RouteComponentProps } from "react-router-dom";
import { Note as NoteModel } from "../Models/Note";
import { NoteCard } from "./NoteCard";
import { PagedNote } from "../Models/PagedNotes";
import { Filter } from "./Filter";
import { FilterProps } from "../Models/FilterProps";
import { RandomPwd } from "./RandomPwd";

interface IProps extends RouteComponentProps {
    onLogout: () => void;
    onNoteEdit: (id: string | undefined) => void;
}
export const Home = (props: IProps): JSX.Element => {
    console.log("Home");
    //get token
    const [notes, setNotes] = useState<NoteModel[]>([]);
    const { onLogout, history, onNoteEdit } = props;
    const pageSize = 20;
    const [activePageNum, setActivePageNum] = useState(1);
    const [pageItems, setPageItems] = useState<JSX.Element[]>([]);
    const [searchText, setSearchText] = useState<string>("");
    const [filterTag,setFilterTag] = useState<string[]>([]);
    const onPageItemClick = (
        event: React.MouseEvent<HTMLElement, MouseEvent>
    ) => {
        let anchor = event.target as HTMLAnchorElement;
        if ((anchor.text)) {
            let pageNum = parseInt(anchor.text);
            if (pageNum > 0) {
                setActivePageNum(pageNum);
            }
        }
    };
    const onNoteDelete = useCallback(
        (id: string | undefined) => {
            if (!id) return;
            let noteArr: NoteModel[] = [];
            //loop on notes
            for (let singleNote of notes) {
                if (singleNote.id !== id) {
                    noteArr.push(singleNote);
                }
            }
            setNotes(noteArr);

            //delete on server
            try {
                Axios.delete(
                    `${process.env.REACT_APP_API_URL}/api/v1/notes/${id}`
                );
            } catch (errors) {
                console.log(errors);
            }
        },
        [notes]
    );

    const updateFilterProps = useCallback((filterProps:FilterProps)=>{
        setSearchText(filterProps.searchText);
        setFilterTag(filterProps.fitlerTags);
    },[setSearchText,setFilterTag]);

    //create request
    useEffect(() => {
        async function getNotes() {
            try {
                const response = await Axios.post(
                    process.env.REACT_APP_API_URL + "/api/v1/paged_notes",
                    {
                        pageNum: activePageNum,
                        pageSize: pageSize,
                        searchText:searchText,
                        tagIds: filterTag
                    }
                );
                let pagedNotes = response.data as PagedNote;
                setNotes(pagedNotes.data as NoteModel[]);

                //add pagination items
                let items: JSX.Element[] = [];
                for (
                    let number = 1;
                    number <= pagedNotes.totalPages;
                    number++
                ) {
                    items.push(
                        <Pagination.Item
                            key={number}
                            active={number === activePageNum}
                            onClick={(e:React.MouseEvent<HTMLElement, MouseEvent>
) => onPageItemClick(e)}
                        >
                            {number}
                        </Pagination.Item>
                    );
                }
                setPageItems(items);
            } catch (error) {
                onLogout();
                //redirect to home
                history?.push("/login", "/");
            }
        }
        getNotes();
    }, [history, onLogout, activePageNum,searchText, filterTag]);

    return (
        <>
            <div className="row justify-content-center">
                <div className="col-12">
                    <Filter updateFilterProps={updateFilterProps}/>
                    <RandomPwd/>
                    {notes.map((note: NoteModel) => (
                        <NoteCard
                            {...props}
                            note={note}
                            onNoteDelete={onNoteDelete}
                            onNoteEdit={onNoteEdit}
                        />
                    ))}
                </div>

                <div>
                    <Pagination>{pageItems}</Pagination>
                </div>
            </div>
        </>
    );
};
